// Styles librairies
import '../libs/masterslider/css/masterslider.main.css'
import '../../scss/components/master-slider'

// Scripts librairies
import '../libs/masterslider/js/jquery.easing.min.js'
/* global MasterSlider */
import '../libs/masterslider/js/masterslider.min.js'
// import PhotoSwipeLightbox from 'photoswipe/lightbox'
// import 'photoswipe/style.css'
//
// Master slider init
const slider = new MasterSlider()
slider.control('arrows')
slider.control('thumblist', {
  autohide: false,
  dir: 'h',
  arrows: false,
  align: 'bottom',
  width: 180,
  height: 127,
  margin: 5,
  space: 5
})
slider.setup('masterslider', {
  width: 1200,
  height: 820,
  space: 5,
  view: 'fade',
  autoplay: true
})

/*
// Photoswipe init
$('body').append('' +
'<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">' +
    '<div class="pswp__bg"></div>' +
    '<div class="pswp__scroll-wrap">' +
        '<div class="pswp__container">' +
            '<div class="pswp__item"></div>' +
            '<div class="pswp__item"></div>' +
            '<div class="pswp__item"></div>' +
        '</div>' +
        '<div class="pswp__ui pswp__ui--hidden">' +
            '<div class="pswp__top-bar">' +
                '<div class="pswp__counter"></div>' +
                '<button class="pswp__button pswp__button--close" title="Fermer (Echap)"></button>' +
                '<button class="pswp__button pswp__button--share" title="Partager"></button>' +
                '<button class="pswp__button pswp__button--fs" title="Plein écran / réduire"></button>' +
                '<button class="pswp__button pswp__button--zoom" title="Zoom +/-"></button>' +
                '<div class="pswp__preloader">' +
                    '<div class="pswp__preloader__icn">' +
                      '<div class="pswp__preloader__cut">' +
                        '<div class="pswp__preloader__donut"></div>' +
                      '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">' +
                '<div class="pswp__share-tooltip"></div>' +
            '</div>' +
            '<button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>' +
            '<button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>' +
            '<div class="pswp__caption">' +
                '<div class="pswp__caption__center"></div>' +
            '</div>' +
        '</div>' +
    '</div>' +
'</div>')
$('.picture').each(function () {
  const $pic = $(this)
  const getItems = function () {
    const items = []
    $pic.find('a').each(function () {
      const $href = $(this).attr('href')
      const $size = $(this).data('size').split('x')
      const $width = $size[0]
      const $height = $size[1]
      const item = {
        src: $href,
        w: $width,
        h: $height
      }
      items.push(item)
    })
    return items
  }
  const items = getItems()
  const $pswp = $('.pswp')[0]
  $pic.on('click', 'figure', function (e) {
    e.preventDefault()
    const $index = $(this).index()
    const options = {
      index: $index,
      bgOpacity: 0.7,
      showHideOpacity: true,
      shareButtons: [
        { id: 'facebook', label: 'Partager sur Facebook', url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}' },
        { id: 'twitter', label: 'Tweeter', url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}' },
        { id: 'pinterest', label: 'Pin it', url: 'https://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}' }
        // {id:'download', label:'Télécharger', url:'{{raw_image_url}}', download:true}
      ]
    }
    // Initialize PhotoSwipe
    const lightbox = new PhotoSwipeLightbox({
      gallery: '#my-gallery',
      children: 'a',
      pswpModule: () => import('photoswipe')
    })
    lightbox.init()
  })
})
*/
